import { useSearchParams } from 'react-router-dom';

export const useOpenAccessBackground = (defaultBg: string = 'bg-backgroundPrimary') => {
    const [params] = useSearchParams();
    return params.has('noBg') ? '' : defaultBg;
};
